import ChartWrapper from "../../shared/chart-kit/components/chart-wrapper/ChartWrapper";
import BarChart from "../../shared/chart-kit/components/barchart/BarChart";
import ConsentTable from "./ConsentTable";

function ConsentSummary(props: any) {
  const {
    profilingConsentData = [],
    profilingData = [],
    targetingConsentPerformance = [],
    emailConsentPerformance = [],
    profilingConsentPerformance = [],
    topBrands = [],
  } = props?.dataReportsDropdown?.data || {};

  return (
    <div className="consent-summary">
      <ConsentTable profilingData={profilingData} />

      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Email Consent All Time Period Performance"}>
            <BarChart data={emailConsentPerformance} horizontal={false} />
          </ChartWrapper>
        </div>
      </div>

      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Targeting Consent All Time Period Performance"}>
            <BarChart data={targetingConsentPerformance} horizontal={false} />
          </ChartWrapper>
        </div>
      </div>

      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Profiling Consent All Time Period Performance"}>
            <BarChart data={profilingConsentPerformance} horizontal={false} />
          </ChartWrapper>
        </div>
      </div>



      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Targeting Consent All Time Period Top 5 Brand Performance"}>
            <BarChart data={topBrands} horizontal={true} />
          </ChartWrapper>
        </div>
      </div>
      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Email Consent All Time Period Top 5 Brand Performance"}>
            <BarChart data={topBrands} horizontal={true} />
          </ChartWrapper>
        </div>
      </div>

      <div className="mt-6">
        <div className="">
          <ChartWrapper title={"Profiling Consent All Time Period Top 5 Brand Performance"}>
            <BarChart data={topBrands} horizontal={true} />
          </ChartWrapper>
        </div>
      </div>

      <div className="home__table-wrap__label mt-6">Brand & Campaign Performance</div>
      <div className="mt-3">
        <ChartWrapper title={"Profiling Consent Data"} subTitle={"Used for LAL"}>
          <BarChart data={profilingConsentData} horizontal={true} />
        </ChartWrapper>
      </div>
      <div className="mt-3">
        <ChartWrapper title={"Email Marketing Consent Data"} subTitle={"Used for direct email"}>
          <BarChart data={profilingConsentData} horizontal={true} />
        </ChartWrapper>
      </div>
      <div className="mt-3">
        <ChartWrapper title={"Targeting Consent Data"} subTitle={"Used for seed audience"}>
          <BarChart data={profilingConsentData} horizontal={true} />
        </ChartWrapper>
      </div>
    </div>
  );
}
export default ConsentSummary;
